/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UserQueryRequest {
    getFixupPrototypeFunction() { return UserQueryRequest.fixupPrototype; }

    static newInstance(model: Partial<UserQueryRequest>): UserQueryRequest {
        let obj = Object.assign(new UserQueryRequest(), model);
        UserQueryRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UserQueryRequest>): UserQueryRequest {
        if (!model) return null;
        return UserQueryRequest.newInstance(<UserQueryRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UserQueryRequest) {
        if (!obj) return;

        models.UserQueryRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UserQueryRequest): boolean {
        Object.setPrototypeOf(obj, UserQueryRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * ID of the chat
     */
    chat_id: string;

    /**
     * ID of the agent
     */
    agent_id: string;

    /**
     * ID of the tenant
     */
    tenant_id: string;

    /**
     * User query
     */
    query: string;

}
